import { SyntaxFixRow } from './SyntaxFixRow';
import type { PlanSectionProps } from './types';

// The fixes affecting one floor plan, so the reviewer works plan by plan.
export const PlanSection = ({
  group,
  acceptedRowKeys,
  editedTargets,
  onToggleRow,
  onEditTarget,
}: PlanSectionProps) => (
  <div className="syntax-plan-section">
    <div className="syntax-plan-title">{group.label}</div>
    {group.rows.map((row) => (
      <SyntaxFixRow
        key={row.key}
        row={row}
        checked={acceptedRowKeys.has(row.key)}
        target={editedTargets[row.key] ?? row.suggested}
        onToggle={onToggleRow}
        onEditTarget={onEditTarget}
      />
    ))}
  </div>
);
